import { useAuth } from './useAuth'
import { useCurrentCompanyUser } from './useCurrentCompanyUser'
import { useCurrentUserOrFail } from './useCurrentUserOrFail'

export function usePermissions() {
  const currentUser = useCurrentUserOrFail()
  const currentCompanyUser = useCurrentCompanyUser()
  const { currentCompany, currentGroup } = useAuth()
  const currentCompanyId = currentCompany?.id
  const currentGroupId = currentGroup?.id
  const permissions = currentUser.permissions

  return {
    canSearchPanels: permissions.includes(`c:${currentCompanyId}/panel/search`),
    canInviteToPanel: permissions.includes(
      `c:${currentCompanyId}/panel/invite`,
    ),
    canManageUsers:
      (currentGroup &&
        permissions.includes(`g:${currentGroupId}/user/admin`)) ||
      (currentCompany &&
        permissions.includes(`c:${currentCompanyId}/user/admin`)),
    canManageCompanyUsers: permissions.includes(
      `c:${currentCompanyId}/user/admin`,
    ),
    canManageGroupUsers: permissions.includes(`g:${currentGroupId}/user/admin`),
    canManageLeadAdvisers: permissions.includes(
      `c:${currentCompanyId}/lead-adviser/edit`,
    ),
    canManageReferralApprovals: permissions.includes(
      `c:${currentCompanyId}/referral-approval-user/edit`,
    ),
    canManagePaymentProfile: permissions.includes(
      `c:${currentCompanyId}/company/payment-profile`,
    ),
    canCreateCompany: permissions.includes(`company/create`),
    canViewRecommendedPartners: permissions.includes(
      `c:${currentCompanyId}/recommended-partner/view`,
    ),
    canAddPanelDirectly: currentCompanyUser?.canAddPanelDirectly ?? false,
  }
}
